<div class="pagination">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="maxSize" [rotate]="rotate"
        [ellipses]="ellipses" [boundaryLinks]="boundaryLinks" (pageChange)="onPageChange($event)"></ngb-pagination>
</div>